import { useMemo } from "react";
import useRolesPermissions from "./useRolesPermissions";
import { CorporationsEntity } from "entities/Corporations/CorporationsEntity";

/**
 * Mirrors useAllowCorporateDashboard but uses the RCA executive scope flag
 * (true for ADMINISTRATOR / OSORNOADMINISTRATOR / EXECUTIVE — same flag that
 * gates the Division/Region filters on RCA/AP Compliance) AND the same
 * multi-mill rule the Downtime Corporate Dashboard already uses.
 */
export const useAllowRCACorporateDashboard = () => {
    const { RCA_PERMISSIONS } = useRolesPermissions();
    const { corporations } = CorporationsEntity.GetMenuCorporateDivisionsRegionsMills();

    const isAllowedToUseRCACorporateDashboard = useMemo(() => {
        if (RCA_PERMISSIONS?.rca_library?.executiveMillsFilter && corporations.length > 0) {
            return corporations[0]?.mills && corporations[0].mills.length > 1;
        }
        return false;
    }, [RCA_PERMISSIONS?.rca_library?.executiveMillsFilter, corporations]);

    const isCorporationsListLoaded = useMemo(() => corporations && corporations.length > 0, [corporations]);

    return { isAllowedToUseRCACorporateDashboard, isCorporationsListLoaded };
};
